import React from "react";

function Indicator({ stepsCount, currStep, filledClass }) {
  return (
    <div className="steps mb-10 mt-2">
      {/* <div className="text-xs mb-1">{`Step ${currStep}/${stepsCount.length}`}</div> */}
      <div className="flex justify-between h-1 -mx-2">
        {stepsCount.map((step, i) => (
          <div
            key={step}
            className={`w-1/${
              stepsCount.length
            } mx-2 rounded-full filled-indicator ${
              step <= currStep ? "bg-pri " + filledClass : "bg-pri-tint-4"
            }`}
          ></div>
        ))}
      </div>
    </div>
  );
}

export default Indicator;
